import axios from 'axios';

const API_BASE =
    process.env.REACT_APP_API_BASE ||
    (window.location.port === '3000' ? 'http://localhost:3001' : '');

const toDateParam = (date) => (date ? date.toISOString().split('T')[0] : null);

export const fetchPrimarySteps = async () => {
    const response = await axios.get(`${API_BASE}/api/distinct-step-numbers`);
    return response.data || [];
};

export const fetchPredictiveFailure = async ({ selectedPrimaryStep, startDate, endDate }) => {
    const response = await axios.get(`${API_BASE}/api/predictive-analysis`, {
        params: {
            primaryStep: selectedPrimaryStep,
            startDate: toDateParam(startDate),
            endDate: toDateParam(endDate),
        },
    });

    return response.data;
};
